import React, { useEffect } from 'react';
// Import safe CSS files directly from src
import '../assets/css/templatemo-seo-dream.css';
import '../assets/css/fontawesome.css';
import '../assets/css/animated.css';
// Note: owl.css is loaded dynamically from public folder to avoid webpack compilation errors

const Home = () => {
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const surname = formData.get('surname');
    const email = formData.get('email');
    const subject = formData.get('subject');
    const message = formData.get('message');
    
    // Create email content
    const emailSubject = subject || 'Mesazh nga Mini Minds Website';
    const emailBody = `
Emri: ${name}
Mbiemri: ${surname}
Email: ${email}
Subjekti: ${subject}

Mesazhi:
${message}
    `;
    
    // Create mailto link
    const mailtoLink = `mailto:minii.minds@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    alert('Email-i po hapet në aplikacionin tuaj të email-it!');
    
    // Reset form
    e.target.reset();
  };

  useEffect(() => {
    // Load owl.css from public folder after DOM is ready
    const loadOwlCSS = () => {
      setTimeout(() => {
        if (!document.querySelector('link[href="/assets/css/owl.css"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = '/assets/css/owl.css';
          document.head.appendChild(link);
        }
      }, 100);
    };
    
    loadOwlCSS();

    // Load script function with error handling
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        // Check if script already exists
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => {
          console.warn(`Failed to load script: ${src}`);
          resolve(); // Resolve anyway to continue loading other scripts
        };
        document.body.appendChild(script);
      });
    };

    // Load scripts sequentially with proper error handling
    const loadAllScripts = async () => {
      try {
        // Load jQuery first
        await loadScript('/vendor/jquery/jquery.min.js');
        
        // Wait a bit for jQuery to initialize
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Load other scripts
        await loadScript('/vendor/bootstrap/js/bootstrap.bundle.min.js');
        await loadScript('/assets/js/owl-carousel.js');
        await loadScript('/assets/js/animation.js');
        await loadScript('/assets/js/imagesloaded.js');
        
        // Load custom.js last and handle errors
        try {
          await loadScript('/assets/js/custom-safe.js');
        } catch (error) {
          console.warn('Custom-safe.js failed to load, continuing without it');
        }
        
        // Initialize components after all scripts load
        initializeComponents();
        
      } catch (error) {
        console.warn('Some scripts failed to load:', error);
        // Still try to initialize basic components
        initializeComponents();
      }
    };

    // Initialize components function
    const initializeComponents = () => {
      // Hide preloader
      setTimeout(() => {
        const preloader = document.getElementById('js-preloader');
        if (preloader) {
          preloader.style.opacity = '0';
          setTimeout(() => {
            preloader.style.display = 'none';
          }, 500);
        }
      }, 1000);

      // Initialize WOW animations if available
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (error) {
          console.warn('WOW animations failed to initialize:', error);
        }
      }

      // Initialize Owl Carousel if available
      if (window.$ && window.$.fn.owlCarousel) {
        setTimeout(() => {
          try {
            window.$('.loop').owlCarousel({
              center: true,
              items: 2,
              loop: true,
              nav: true,
              margin: 45,
              responsive: {
                991: { items: 4 },
                767: { items: 3 },
                479: { items: 2 }
              }
            });
          } catch (error) {
            console.warn('Owl Carousel failed to initialize:', error);
          }
        }, 200);
      }
    };

    // Start loading scripts after DOM is ready
    setTimeout(loadAllScripts, 100);

    // Cleanup function
    return () => {
      // Remove dynamically added scripts on unmount
      const scripts = document.querySelectorAll('script[src*="/vendor/"], script[src*="/assets/js/"]');
      scripts.forEach(script => {
        try {
          script.remove();
        } catch (error) {
          console.warn('Error removing script:', error);
        }
      });
    };
  }, []);

  return (
    <div>
      {/* ***** Preloader Start ***** */}
      <div id="js-preloader" className="js-preloader">
        <div className="preloader-inner">
          <span className="dot"></span>
          <div className="dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      {/* ***** Preloader End ***** */}

      {/* ***** Header Area Start ***** */}
      <header className="header-area header-sticky wow slideInDown" data-wow-duration="0.75s" data-wow-delay="0s">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="main-nav">
                {/* ***** Logo Start ***** */}
                <a href="index.html" className="logo">
                  <h4>Mini Minds 🧩 </h4>
                </a>
                {/* ***** Logo End ***** */}
                {/* ***** Menu Start ***** */}
                <ul className="nav">
                  <li className="scroll-to-section"><a href="#top" className="active">Ballina</a></li>
                 {/* <li className="scroll-to-section"><a href="#features">Funksionalitetet</a></li> */}
                  <li className="scroll-to-section"><a href="#about">Rreth Nesh</a></li>
                  <li className="scroll-to-section"><a href="#services">Shërbimet</a></li>
                  <li className="scroll-to-section"><a href="#portfolio">Portofoli</a></li>
                  <li className="scroll-to-section"><a href="#contact">Kontaktoni</a></li>
                  <li className="scroll-to-section"><div className="main-blue-button"><a href="#contact">Merrni Ofertën Tuaj</a></div></li>
                </ul>
                <a className='menu-trigger'>
                    <span>Menu</span>
                </a>
                {/* ***** Menu End ***** */}
              </nav>
            </div>
          </div>
        </div>
      </header>
      {/* ***** Header Area End ***** */}

      <div className="main-banner wow fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6 align-self-center">
                  <div className="left-content header-text wow fadeInLeft" data-wow-duration="1s" data-wow-delay="1s">
                    <div className="row">
                      <div className="col-lg-4 col-sm-4">
                        <div className="info-stat">
                          <h6>Statusi i Qëndrimit Ditor:</h6>
                          <h4>E Hënë - E Premte</h4>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4">
                        <div className="info-stat">
                          <h6>Orari:</h6>
                          <h4>08:00 - 17:00</h4>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4">
                        <div className="info-stat">
                          <h6>Mosha e fëmijëve:</h6>
                          <h4>3 - 12 vjeç</h4>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <h2>MiniMinds</h2>
                            <p>
                              Ku lumturia dhe mësimi rriten bashkë. 
                              Një ambient i sigurt dhe kreativ për fëmijët tuaj – 
                              me aktivitete edukative, lojëra zhvilluese dhe kujdes profesional çdo ditë.
                            </p>
                      </div>
                      <div className="col-lg-12">
                        <div className="main-green-button scroll-to-section">
                          <a href="#contact">Na kontaktoni</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="right-image wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.5s">
                    <img src="/assets/images/miniminds-right.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
{/*}
      <div id="features" className="features section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="features-content">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="features-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                      <div className="first-number number">
                        <h6>01</h6>
                      </div>
                      <div className="icon"></div>
                      <h4>Reach Out</h4>
                      <div className="line-dec"></div>
                      <p>This HTML5 template is based on Bootstrap 5 CSS. You are free to customize anything.</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="features-item second-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                      <div className="second-number number">
                        <h6>02</h6>
                      </div>
                      <div className="icon"></div>
                      <h4>Develop a Strategy</h4>
                      <div className="line-dec"></div>
                      <p>Lorem ipsum dolor sit ameter consectetur adipiscing li elit sed do eiusmod.</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="features-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                      <div className="third-number number">
                        <h6>03</h6>
                      </div>
                      <div className="icon"></div>
                      <h4>Implementation</h4>
                      <div className="line-dec"></div>
                      <p>If this template is useful for your website, please consider to <a href="https://www.paypal.me/templatemo" target="_blank" rel="nofollow noreferrer">support us</a> a little.</p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="features-item second-feature last-features-item wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                      <div className="fourth-number number">
                        <h6>04</h6>
                      </div>
                      <div className="icon"></div>
                      <h4>Analyze the result</h4>
                      <div className="line-dec"></div>
                      <p>Below circular progress bar animation supports those CSS values 10, 20, 30, till 100.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="skills-content">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0s">
                      <div className="progress" data-percentage="80">
                        <span className="progress-left">
                          <span className="progress-bar"></span>
                        </span>
                        <span className="progress-right">
                          <span className="progress-bar"></span>
                        </span>
                        <div className="progress-value">
                          <div>
                            80%<br />
                            <span>HTML/CSS/JS</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                      <div className="progress" data-percentage="60">
                        <span className="progress-left">
                          <span className="progress-bar"></span>
                        </span>
                        <span className="progress-right">
                          <span className="progress-bar"></span>
                        </span>
                        <div className="progress-value">
                          <div>
                            60%<br />
                            <span>Wordpress</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
                      <div className="progress" data-percentage="90">
                        <span className="progress-left">
                          <span className="progress-bar"></span>
                        </span>
                        <span className="progress-right">
                          <span className="progress-bar"></span>
                        </span>
                        <div className="progress-value">
                          <div>
                            90%<br />
                            <span>Marketing</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="skill-item last-skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.6s">
                      <div className="progress" data-percentage="70">
                        <span className="progress-left">
                          <span className="progress-bar"></span>
                        </span>
                        <span className="progress-right">
                          <span className="progress-bar"></span>
                        </span>
                        <div className="progress-value">
                          <div>
                            70%<br />
                            <span>Photoshop</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
*/}
      <div id="about" className="about-us section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="left-image wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.5s">
                <img src="/assets/images/about-left-image.png" alt="" />
              </div>
            </div>
            <div className="col-lg-6 align-self-center wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.5s">
              <div className="section-heading">
                <h6>Rreth Nesh</h6>
                <h2>Ku <em>lumturia</em> dhe <span>mësimi rriten bashkë</span>.</h2>
              </div>
        {/* 

              <div className="row">
                <div className="col-lg-4 col-sm-4">
                  <div className="about-item">
                    <h4>750+</h4>
                    <h6>projects finished</h6>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4">
                  <div className="about-item">
                    <h4>340+</h4>
                    <h6>happy clients</h6>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4">
                  <div className="about-item">
                    <h4>128+</h4>
                    <h6>awards</h6>
                  </div>
                </div>
              </div> */}
              <p>Misioni i Mini Minds është të krijojë një ambient ku çdo fëmijë ndihet i lumtur, i sigurt dhe i motivuar për të mësuar e për t'u zhvilluar çdo ditë. <br /> <br />Vizioni i Mini Minds është të ofrojë një mjedis të sigurt, edukativ dhe argëtues, ku çdo fëmijë zhvillon aftësitë e tij sociale, emocionale dhe njohëse, duke u rritur me dashuri dhe besim.</p>
            </div>
          </div>
        </div>
      </div>

      <div id="services" className="our-services section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="section-heading wow bounceIn" data-wow-duration="1s" data-wow-delay="0.2s">
                <h6>Shërbimet tona</h6>
                <h2>Zbuloni se çfarë bëjmë  &amp; <span>Ofrojmë</span> Klientëve Tanë</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      🌟   
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4>Shërbimet tona</h4>
                      <p>Në Mini Minds, çdo ditë është një udhëtim i vogël plot buzëqeshje, mësim dhe krijimtari.
Ne ofrojmë një mjedis të sigurt dhe frymëzues, ku fëmijët rriten me dashuri dhe besim në vetvete.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      ✏️
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4>Mbështetje në detyrat e shtëpisë</h4>
                      <p>Kujdesemi që çdo fëmijë të ketë mbështetjen e duhur në realizimin e detyrave të shtëpisë. Përmes udhëzimit individual, ndihmojmë fëmijët të kuptojnë më mirë mësimet dhe të zhvillojnë pavarësinë në të nxënë.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      🧩
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4>Mësim përmes lojës</h4>
                      <p>Ne besojmë se lojërat janë mënyra më e bukur për të mësuar! Përmes tyre, fëmijët zhvillojnë aftësitë njohëse, gjuhësore dhe sociale.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      🎨
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4> Aktivitete kreative</h4>
                      <p>Në Mini Minds, çdo fëmijë është një artist!
Pikturë, ngjyrosje, punime artizanale dhe lojëra imagjinative që zhvillojnë krijimtarinë, përqendrimin dhe shprehjen personale.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.7s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      💛
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4>Zhvillim emocional dhe social</h4>
                      <p>Çdo fëmijë ka një histori unike dhe ne e respektojmë këtë.
Ndihmojmë fëmijët të shprehin ndjenjat, të ndërveprojnë pozitivisht dhe të ndërtojnë miqësi të shëndetshme.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.8s">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="icon">
                      🥗
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="right-content">
                      <h4>Ushqim i shëndetshëm dhe i balancuar</h4>
                      <p>Ushqimi është pjesë e kujdesit tonë të përditshëm.
Ofrojmë vakte të përgatitura me dashuri dhe përbërës të freskët, të përshtatura për moshën dhe nevojat ushqyese të fëmijëve.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="portfolio" className="our-portfolio section">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="section-heading wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.3s">
                <h6>Portofoli Ynë</h6>
                <h2>Zbuloni <em>Aktivitet</em> tona  Dhe <span>Shfaqjet</span></h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid wow fadeIn" data-wow-duration="1s" data-wow-delay="0.7s">
          <div className="row">
            <div className="col-lg-12">
              <div className="loop owl-carousel">
                <div className="item">
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img1.png" alt="" />
                      <div className="">
                       {/**  <div className="inner-content">
                          <a href="#"><h4>Awesome Project 101</h4></a>
                          <span>Marketing</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img2.png" alt="" />
                      <div className="">
                        {/**  <div className="inner-content">
                          <a href="#"><h4>Awesome Project 102</h4></a>
                          <span>Branding</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img3.png" alt="" />
                      <div className="">
                        {/**  <div className="inner-content">
                          <a href="#"><h4>Awesome Project 103</h4></a>
                          <span>Consulting</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img4.png" alt="" />
                      <div className="">
                         {/* <div className="inner-content">
                          <a href="#"><h4>Awesome Project 104</h4></a>
                          <span>Artwork</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img5.png" alt="" />
                      <div className="">
                       {/* <div className="inner-content">
                          <a href="#"><h4>Awesome Project 105</h4></a>
                          <span>Branding</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img6.png" alt="" />
                      <div className="">
                       {/* <div className="inner-content">
                          <a href="#"><h4>Awesome Project 106</h4></a>
                          <span>Artwork</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img7.png" alt="" />
                      <div className="">
                       {/* <div className="inner-content">
                          <a href="#"><h4>Awesome Project 107</h4></a>
                          <span>Creative</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-item">
                    <div className="thumb">
                      <img src="/assets/images/img15.png" alt="" />
                      <div className="">
                       {/* <div className="inner-content">
                          <a href="#"><h4>Awesome Project 108</h4></a>
                          <span>Consulting</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="contact" className="contact-us section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.25s">
              <form id="contact" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 offset-lg-3">
                    <div className="section-heading">
                      <h6>Na kontaktoni</h6>
                      <h2>Plotësoni formularin më poshtë për të <span>kontaktuar</span> me ne</h2>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6">
                        <fieldset>
                          <input type="text" name="name" id="name" placeholder="Emri juaj" autoComplete="on" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-6">
                        <fieldset>
                          <input type="text" name="surname" id="surname" placeholder="Mbiemri juaj" autoComplete="on" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-6">
                        <fieldset>
                          <input type="email" name="email" id="email" placeholder="Email-i juaj" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-6">
                        <fieldset>
                          <input type="text" name="subject" id="subject" placeholder="Subjekti" autoComplete="on" />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea name="message" className="form-control" id="message" placeholder="Mesazhi juaj" required></textarea>  
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="main-button">Dërgo Mesazhin</button>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="contact-info">
                      <ul>
                        <li>
                          <div className="icon">
                            <img src="/assets/images/contact-icon-01.png" alt="email icon" />
                          </div>
                          <a href="mailto:minii.minds@gmail.com">minii.minds@gmail.com</a>
                        </li>
                        <li>
                          <div className="icon">
                            <img src="/assets/images/contact-icon-02.png" alt="phone" />
                          </div>
                          <a href="tel:+38349597463">+383 (49) 597 463</a>
                        </li>
                        <li>
                          <div className="icon">
                            <img src="/assets/images/contact-icon-03.png" alt="location" />
                          </div>
                          <a href="#">Evlia Qelebia, Mitrovica, Kosovo 40000</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
                          <div className="col-lg-12">
              <p>Copyright © 2025 MiniMinds. All Rights Reserved
              
              <br />Develop & Designed by: <a href="https://nitecom.online" title="Software Company">NiteCom</a></p>
            </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
